// @ts-strict-ignore
import { MainStoreState } from 'store/main/MainStoreState';
import { getItem } from 'utils/localStorage';

export const isStaff = (user: MainStoreState['currentUser'] | undefined) =>
  user && user.permissions && user.permissions.includes('staff');

export const isLoggedIn = (user?: MainStoreState['currentUser']): boolean =>
  user !== undefined && user !== null && user.id !== null;

export const isNonAdmin = (user: MainStoreState['currentUser']) =>
  Boolean(
    user &&
      user.id &&
      user.permissions &&
      !user.permissions.includes('staff') &&
      !user.permissions.includes('orgAdmin')
  );

export const isLocationInCountry = (
  user: MainStoreState['currentUser'],
  countryCode: string
) => user && user.location && user.location.countryCode === countryCode;

export const isSalarySurveyCompleted = (
  user: MainStoreState['currentUser']
) => {
  if (user && user.id) {
    return Boolean(user.salarySurvey && user.salarySurvey.lastSubmitted);
  }

  return Boolean(getItem('salarySurveyLastSubmitted'));
};

export const salarySurveyLastSubmittedDate = (
  user: MainStoreState['currentUser']
) => {
  if (user && user.id) {
    return user.salarySurvey && user.salarySurvey.lastSubmitted;
  }

  const localStorageLastSubmitted = getItem('salarySurveyLastSubmitted');

  if (Array.isArray(localStorageLastSubmitted)) {
    return localStorageLastSubmitted[0];
  }

  return null;
};
